import {HelitecnicaLogo} from "@project/components/branding/helitecnica-logo";
import {Button, Card} from "@project/design-system-web";
import {createFileRoute} from "@tanstack/react-router";

import {startDefaultLogin} from "./-auth-status-actions";

export const Route = createFileRoute("/account-not-linked")({
  component: AccountNotLinkedPage,
});

export function AccountNotLinkedPage() {
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-sm gap-4">
        <Card.Header className="items-center gap-3">
          <HelitecnicaLogo className="block h-16 w-56" />
          <Card.Title>Account not linked</Card.Title>
          <Card.Description>
            Your identity was authenticated, but your ERP account is not linked. Contact an
            administrator if this persists.
          </Card.Description>
        </Card.Header>
        <Card.Footer>
          <Button className="w-full" onPress={startDefaultLogin}>
            Try again
          </Button>
        </Card.Footer>
      </Card>
    </main>
  );
}
